import React from 'react';
import { Chip } from '@mui/material';

const STATUS_CONFIG = {
  missing: { label: 'Localisation absente', color: 'error' },
  pending: { label: 'À traiter', color: 'warning' },
  queued: { label: 'En attente', color: 'info' },
  running: { label: 'Traitement en cours', color: 'info' },
  succeeded: { label: 'Réparation terminée', color: 'success' },
  complete: { label: 'Localisation complète', color: 'success' },
  needs_review: { label: 'À vérifier', color: 'warning' },
  failed: { label: 'Échec de localisation', color: 'error' },
};

const LocationStatusChip = ({ status, size = 'small' }) => {
  const config = STATUS_CONFIG[status] || {
    label: status || 'Statut inconnu',
    color: 'default',
  };

  return (
    <Chip
      size={size}
      color={config.color}
      variant={status === 'complete' ? 'outlined' : 'filled'}
      label={config.label}
      sx={{ fontWeight: 700 }}
    />
  );
};

export default LocationStatusChip;
